module.exports = __webpack_public_path__ + "static/media/logoinvert.1c156ffb.svg";